import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/globals.scss";
import { loadFonts } from "./utils/fontLoader";

import { Home, PageNotFoundComponent, CoffeeDrinksPage, ContactForm, AboutUs } from "./pages";
import Header from "./components/Header";

//swipper style
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ScrollToTop from "./components/scrollToTop";
import Footer from "./components/Footer";
import InstallGuide from "./pages/InstallGuide";
import CartPage from "./pages/CartPage";
import { CoffeeFreshPage } from "./pages/coffee/fresh";
import CoffeeArticle from "./pages/coffee/storage";
import CoffeeHistoryPage from "./pages/coffee/history";
import CoffeeCaffeinePage from "./pages/coffee/cafein";
import CoffeeBrewingGuide from "./pages/coffee/brewing";


function App() {
  const location = useLocation();
  const isInstallPage = location.pathname === "/";
  // Load fonts when the app mounts
  useEffect(() => {
    loadFonts();
  }, []);

  return (
    <>

      <main className="font-sans relative flex flex-col min-h-screen">
        <ScrollToTop />
        {!isInstallPage && <Header />}

        <div className={`flex-grow ${!isInstallPage ? "pt-16" : ""}`}>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/coffee/drinks" element={<CoffeeDrinksPage />} />
          <Route path="/coffee/fresh" element={<CoffeeFreshPage />} />
          <Route path="/coffee/storage" element={<CoffeeArticle />} />
          <Route path="/coffee/history" element={<CoffeeHistoryPage />} />
          <Route path="/coffee/cafein" element={<CoffeeCaffeinePage />} />
          <Route path="/coffee/brewing" element={<CoffeeBrewingGuide />} />
          <Route path="/contact-us" element={<ContactForm />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/" element={<InstallGuide />} />
          <Route path="*" element={<PageNotFoundComponent />} />
        </Routes>
        </div>

        {!isInstallPage && <Footer />}

        <ToastContainer
          position="bottom-center"
          autoClose={false}
          closeOnClick
          theme="colored"
          pauseOnFocusLoss={false}
          className="toastContainer" 
          limit={1}
        />
      </main>

      <style
        dangerouslySetInnerHTML={{
          __html: `
          [class*=Mui] {
            font-family: var(IranSans, sans-serif) !important;
          }
        `,
        }}
      />
    </>
  );
}

export default App;
